export const SWIPE_TOGGLE = 'SWIPE_TOGGLE';
